import script from "./entrance.vue?vue&type=script&setup=true&lang=js"
export * from "./entrance.vue?vue&type=script&setup=true&lang=js"

import "./entrance.vue?vue&type=style&index=0&id=182aa7c6&lang=scss"

const __exports__ = script;

export default __exports__